import RoomApi from '../../api/src/room/api/RoomApi'
const roomApi = new RoomApi();
const state = {
    roomTree: []
  };

// const roomDict = {
//     id: 1,
//     name: '校区1',
//     children: [
//         {
//             id: 11,
//             name: '楼栋1',
//             children: [
//                 {
//                     id: 111,
//                     name: '寝室11'
//                 },{
//                     id: 112,
//                     name: '寝室12'
//                 }
//             ]
//         },{
//             id: 12,
//             name: '楼栋2',
//             children: [
//                 {
//                     id: 121,
//                     name: '寝室21'
//                 },{
//                     id: 122,
//                     name: '寝室22'
//                 }
//             ]
//         }
//     ]
//   }

const  mutations =  {
    overGetRoomList (state, payload) {
      state.roomTree = payload
    }
  }

const actions = {
  async getRoomList ({ commit }) {
    let resp = await roomApi.findAll();
    let roomTree = resp[0].children;
    for(let i = 0; i < roomTree.length; i++){
        roomTree[i].label = roomTree[i].name
        roomTree[i].value = roomTree[i].id
        if(roomTree[i].children){
            for(let j = 0; j < roomTree[i].children.length; j++){
                roomTree[i].children[j].label = roomTree[i].children[j].name
                roomTree[i].children[j].value = roomTree[i].children[j].id
              }
        }
    }
    commit('overGetRoomList', roomTree)
    return roomTree
  }
}

  export default {
    namespaced: true,
    state,
    actions,
    mutations
  }